import type { FC } from 'react';

import TextMulti from '../../../../components/fields/text_multi/text_multi';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['placeholder'] as const;

const Field = formField(TextMulti, {
  defaultValue: [],
  transformProps: (props) => pickProps(props, componentProps),
});

export type TextMultiFieldWrapperProps = FieldWrapperProps<typeof Field>;

/**
 * @deprecated Use `ArrayTextField` from `@iconik-io/uad` instead. Note that it
 * has no `labelWidth` equivalent, so a migrated call site changes layout.
 */
const TextMultiFieldWrapper: FC<TextMultiFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default TextMultiFieldWrapper;
